import { useContext, useEffect, useState } from 'react'
import Modal, { ModalBody, ModalHeader } from '../../../../common/Modal'
import {
  CapitalHarnessContext,
  SET_SHOW_HIDE_DETAILS_POPUP,
} from '../context/context'
import { getRequest } from '../../../../../services/base'
import { useParams } from 'react-router-dom'
import LinkWithStatus from '../../../../common/LinkWithStatus'
import { downloadFile } from '../../../../../utils/common'
import { NavContext } from '../../../../../context/global_context'

const FILE_CONFIG = {
  0: `wire_list.csv`,
  1: `connector_list.csv`,
  2: `harness.csv`,
}

const CapitalHarnessDetails = () => {
  const { vehicle } = useParams()
  const [resultData, setResultData] = useState([])

  const [state, dispatch] = useContext(CapitalHarnessContext)
  const [navState, navDispatch] = useContext(NavContext)

  useEffect(() => {
    getCapitalHarnessDetails()
  }, [])

  const getCapitalHarnessDetails = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: `Loading Capital Harness Files`,
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(
      `/api/plugin/capital_harness_result/?vehicle=${vehicle}&capital_harness=${state?.showDetailsPopup.id}`
    )
    setResultData(res?.results)
    navDispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  return (
    <Modal
      onClose={() => {
        dispatch({ type: SET_SHOW_HIDE_DETAILS_POPUP, data: false })
      }}
      show={true}
      size={'w-1/2'}
    >
      <ModalHeader className={'text-white'}>
        {state?.showDetailsPopup.name} - Capital Harness Details
      </ModalHeader>
      <ModalBody>
        {resultData?.map((result, resultIdx) => {
          return (
            <div
              className="flex align-center text-white"
              key={`capital-harness-file-${resultIdx}`}
            >
              <LinkWithStatus
                href={``}
                className="underline py-1 px-2"
                title={`Download ${FILE_CONFIG[result.file_type]}`}
                onClickFunc={() => {
                  downloadFile(
                    `${result?.result_file}?timestamp=${Number(new Date())}`,
                    FILE_CONFIG[result.file_type]
                  )
                }}
              />
            </div>
          )
        })}

        <div className="flex align-center justify-end">
          <LinkWithStatus
            href={``}
            className="btn py-1 px-2"
            title={`Download Source File`}
            onClickFunc={() => {
              downloadFile(
                `${state?.showDetailsPopup?.capital_harness_file}?timestamp=${Number(new Date())}`,
                `${state?.showDetailsPopup?.name}.xml`
              )
            }}
          />
        </div>
      </ModalBody>
    </Modal>
  )
}

export default CapitalHarnessDetails
